/* eslint-disable camelcase */
/* eslint-disable radix */
/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import MaxLengthNumericEditor from '../../../../../SharedModules/CustomAgGridEditor/inputComponent';
import * as Styles from '../../../../../SharedModules/StyleConstant/StyleConstant';
import {
  NumberAndAlphabetComparator,
  updateHeaderArray,
} from '../../../../../SharedModules/utilities/utilities';
import { caseInsensitiveComparator } from '../../../../Display/NDC/utility/tableHeads';

function monthToComparableNumber(date) {
  if (date === undefined || date === null || date.length !== 10) {
    return null;
  }

  const yearNumber = Number.parseInt(date.substring(6, 10));
  const dayNumber = Number.parseInt(date.substring(3, 5));
  const monthNumber = Number.parseInt(date.substring(0, 2));
  return yearNumber * 10000 + monthNumber * 100 + dayNumber;
}
export function dateComparator(date1, date2) {
  const date1Number = monthToComparableNumber(date1);
  const date2Number = monthToComparableNumber(date2);

  if (date1Number === null && date2Number === null) {
    return 0;
  }
  if (date1Number === null) {
    return -1;
  }
  if (date2Number === null) {
    return 1;
  }

  return date1Number - date2Number;
}

export const manuFactureHead = [
  {
    headerName: 'Manufacturer ID',
    field: 'mfgId',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    // comparator: NumberAndAlphabetComparator,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Manufacturer Name',
    field: 'mfgName',
    editable: false,
    sortable: true,
    resizable: false,
    suppressMenu: false,
    minWidth: Styles.Width_250,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'RenderMFGName',
    cellClass: 'frr-ellipsis-text',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];
export const labelerHead = [
  {
    headerName: 'Labeler Code',
    field: 'labelerCode',
    editable: false,
    sortable: true,
    sort: 'asc',
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    sortingOrder: ['desc', 'asc'],
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Labeler Name',
    field: 'labelerName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: false,
    minWidth: Styles.Width_150,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'RenderLabelerName',
    cellClass: 'frr-ellipsis-text',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    comparator: caseInsensitiveComparator,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];
export const CommercialLabelerHead = [
  {
    headerName: 'Comments Exists',
    field: 'ccCommentsExist',
    hideFilterIcon: true,
    filter: false,
    sortable: false,
    enableMenu: false,
    showCheckboxIcon: true,
    minWidth: Styles.Width_150,
    resizable: true,
    editable: false,
    suppressMenu: false,
    autoHeight: true,
    wrapText: true,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'DeleteBoxRender',
    cellStyle: { 'border-right-color': Styles.BorderColor },
  },

  {
    headerName: 'Labeler Code',
    field: 'labelerCode',
    sort: 'asc',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_160,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Name',
    field: 'labelerName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    columnSpan: 3,
    minWidth: Styles.Width_320,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    cellRenderer: 'labelerNameRender',
    cellClass: 'frr-ellipsis-text',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: 'Start Date',
    field: 'startDate',
    comparator: dateComparator,
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_180,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'StartDate',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'End Date',
    field: 'endDate',
    comparator: dateComparator,
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: false,
    minWidth: Styles.Width_160,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'EndDate',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const MFG_Select_LabelerHead = [
  {
    headerName: 'Select',
    enableMenu: false,
    field: 'value',
    hideFilterIcon: true,
    showCheckboxIcon: true,
    minWidth: Styles.Width_100,
    editable: false,
    suppressMenu: false,
    sortable: false,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'CheckBox',
    cellStyle: { 'border-right-color': Styles.BorderColor },
  },
  {
    headerName: 'Labeler Code',
    field: 'labelerCode',
    sort: 'asc',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_180,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Name',
    field: 'labelerName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    columnSpan: 3,
    minWidth: Styles.Width_400,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    cellRenderer: 'labelerNameRender',
    filter: 'agTextColumnFilter',
    cellClass: 'frr-ellipsis-text',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: 'Date Available',
    field: 'lastUpdateDt',
    editable: false,
    sortable: true,
    resizable: false,
    suppressMenu: false,
    minWidth: Styles.Width_180,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];
export const contractsHead = [
  {
    headerName: 'Contract Number',
    field: 'contractSeqNum',
    sort: 'asc',
    editable: false,
    sortable: true,
    suppressMenu: false,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    minWidth: Styles.Width_130,
    excelAlignment: 'right',
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'contractCodeRender',
    cellStyle: { textAlign: 'right', 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Rebate Program',
    field: 'rebateProgramCd',
    editable: false,
    sortable: true,
    suppressMenu: false,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    minWidth: Styles.Width_130,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Contract Name',
    field: 'contractName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    columnSpan: 3,
    minWidth: Styles.Width_270,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    cellRenderer: 'contractNameRender',
    cellClass: 'frr-ellipsis-text',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: 'Start Date',
    field: 'startDt',
    comparator: dateComparator,
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_150,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'StartDate',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'End Date',
    field: 'endDt',
    comparator: dateComparator,
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_150,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'EndDate',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Coverage Gap Indicator',
    field: 'covGapIndicator',
    editable: false,
    sortable: false,
    suppressMenu: false,
    resizable: false,
    hideFilterIcon: true,
    showCheckboxIcon: true,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    minWidth: Styles.Width_130,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'CheckBox',
    cellStyle: { 'border-right-color': Styles.BorderColor },
  },
];
export const contractsUsingContactHead = [
  {
    headerName: 'Contract Name',
    field: 'contractName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    columnSpan: 3,
    minWidth: Styles.Width_250,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'contractNameRender',
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    cellClass: 'frr-ellipsis-text',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: 'Manufacturer ID',
    field: 'mfgId',
    editable: false,
    sortable: true,
    sort: 'asc',
    suppressMenu: false,
    minWidth: Styles.Width_180,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },

  {
    headerName: 'Start Date',
    field: 'startDt',
    comparator: dateComparator,
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_150,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    cellRenderer: 'StartDate',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'End Date',
    field: 'endDt',
    comparator: dateComparator,
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_150,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    cellRenderer: 'EndDate',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Rebate Program Code',
    field: 'rebateProgramCd',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: false,
    minWidth: 220,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];
export const BankruptcyHead = (kcRoles) =>
  updateHeaderArray(
    [
      {
        headerName: 'Comments Exists',
        field: 'ccCommentsExist',
        hideFilterIcon: true,
        filter: false,
        sortable: false,
        enableMenu: false,
        showCheckboxIcon: true,
        minWidth: Styles.Width_150,
        resizable: true,
        editable: false,
        suppressMenu: false,
        cellEditor: MaxLengthNumericEditor,
        cellRenderer: 'DeleteBoxRender',
        cellStyle: { 'border-right-color': Styles.BorderColor },
      },
      {
        headerName: 'Type',
        field: 'bankruptcyTypeCd',
        editable: false,
        columnSpan: 3,
        suppressMenu: false,
        sortable: true,
        minWidth: Styles.Width_320,
        cellRenderer: 'SelectionBoxRender',
        cellClass:
          'frr-bankruptcy-type frr-ellipsis-text-overlap frr-ellipsis-text',
        showDropDownVal: true,
        dropDownValueCol: 'bankruptcyTypeCdValWithLabel',
        cellEditor: MaxLengthNumericEditor,
        maxLength: Styles.Length_50,
        isNumber: true,
        filter: 'agTextColumnFilter',
        sortingOrder: ['desc', 'asc'],
        cellStyle: { 'border-right-color': Styles.BorderColor },
        filterParams: {
          defaultOption: 'startsWith',
          suppressAndOrCondition: true,
          buttons: ['reset'],
          refreshValuesOnOpen: true,
        },
      },
      {
        headerName: '',
        field: '',
        removeColumn: true,
        minWidth: 1,
        resizable: false,
      },
      {
        headerName: '',
        field: '',
        removeColumn: true,
        minWidth: 1,
        resizable: false,
      },
      {
        headerName: 'Start Date',
        field: 'startDate',
        comparator: dateComparator,
        editable: false,
        sortable: true,
        suppressMenu: false,
        minWidth: Styles.Width_160,
        cellEditor: MaxLengthNumericEditor,
        maxLength: Styles.Width_200,
        cellRenderer: 'StartDate',
        sortingOrder: ['desc', 'asc'],
        cellStyle: { 'border-right-color': Styles.BorderColor },
        filter: 'agTextColumnFilter',
        filterParams: {
          defaultOption: 'startsWith',
          suppressAndOrCondition: true,
          buttons: ['reset'],
          refreshValuesOnOpen: true,
        },
      },
      {
        headerName: 'End Date',
        field: 'endDate',
        comparator: dateComparator,
        cellRenderer: 'EndDate',
        editable: false,
        suppressMenu: false,
        sortable: true,
        minWidth: Styles.Width_160,
        cellEditor: MaxLengthNumericEditor,
        maxLength: Styles.Width_200,
        cellStyle: { 'border-right-color': Styles.BorderColor },
        filter: 'agTextColumnFilter',
        sortingOrder: ['desc', 'asc'],
        filterParams: {
          defaultOption: 'startsWith',
          suppressAndOrCondition: true,
          buttons: ['reset'],
          refreshValuesOnOpen: true,
        },
      },

      {
        headerName: 'Include Claims Prior to Bankruptcy in Invoice',
        field: 'inclInvoiceInd',
        editable: false,
        minWidth: Styles.Width_200,
        hideFilterIcon: true,
        showCheckboxIcon: true,
        wrapHeaderText: true,
        autoHeaderHeight: true,
        cellRenderer: 'CheckBox',
        suppressMenu: false,
        sortable: false,
        resizable: false,
        sortingOrder: ['desc', 'asc'],
        cellEditor: MaxLengthNumericEditor,
        filter: 'agTextColumnFilter',
        filterParams: {
          defaultOption: 'startsWith',
          suppressAndOrCondition: true,
          buttons: ['reset'],
          refreshValuesOnOpen: true,
        },
      },
    ],
    kcRoles
  );
